import React from 'react';
import { Show, FunctionField, ReferenceArrayField, SingleFieldList, SimpleShowLayout, required, number, minValue,
    Toolbar, AutocompleteArrayInput, BooleanInput, NumberField, DateField, DateInput, NumberInput, TabbedForm, FormTab,
    SelectArrayInput, ArrayInput, SimpleFormIterator, Edit, Create, EditButton, Filter, List, Datagrid, TextField,
    TextInput, ReferenceArrayInput, SelectInput, BooleanField, ReferenceField, FormDataConsumer, AutocompleteInput,
    ReferenceInput, Button} from 'react-admin';
import { Box, Card, CardContent, CardHeader } from '@material-ui/core';
import {
  TopLevelDomainFilter, PublisherFilter, DeviceTypeFilter, SegmentFilter, IABCategoriesFilter,
  PageUrlFilter, CountryFilter, StateFilter, DivIDFilter, ViewabilityFilter, OSFilter, AsnFilter,
  ChannelFilter, ImpressionTypeFilter, PlacementFilter, MultipleChoiceFilter, IpListsFilter,
  browserChoices, UserAgentFilter
} from './common/filters/Filters';
import { CopyIconButton, CopyButton } from './components/CopyButton';
import ReachSliderInput from './components/ReachSliderInput';
import AdvertiserMarginField from './components/AdvertiserMarginField';
import AdvertiserDynamicPricingToggle from './components/AdvertiserDynamicPricingToggle';
import CampaignPerformancePanel from './components/CampaignPerformancePanel';
import { CampaignStatusBanner, CampaignStatusChip, AUDIENCE } from './components/campaignStatus';
import { isAdminRole } from './components/utils';
import ErrorAwareFormTabs from './components/ErrorAwareFormTabs';
import { ValidatingSaveButton } from './components/ValidatingSaveButton';
import { makeStyles } from '@material-ui/core/styles';
const {validInteger, validFrequencyCap, validFrequencyHours, requireSomeSpendLimit, validCampaignName} = require('./components/validation.js');
const utils = require('./components/utils');

const CampaignTitle = ({ record }) => {
    return <span>
        {record && record.name ? `Edit Campaign "${record.name}" ${record.active ? 'ACTIVE' : 'INACTIVE'}` : 'Create Campaign' }
    </span>
    ;
};

const CampaignFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="search_name" alwaysOn resettable />
        <BooleanInput source="owned" defaultValue='true' label="Owned By Me" style={{}} resettable />
        <BooleanInput source="active" defaultValue='true' label="Active" style={{}} resettable />
        <ReferenceArrayInput source="advertiser_id"
            reference="advertisers"
            basePath='advertisers'
            perPage={10}
            sort={{ field: 'name', order: 'ASC' }}
            filterToQuery={searchText => ({ search_name: searchText })}>
            <AutocompleteArrayInput label="Advertisers" optionText="name" optionValue="code" style={{ width: '90%' }} />
        </ReferenceArrayInput>
    </Filter>
);
const FilterArrayField = (props) => {
	let record = props.record;
	let field = props.field;
	let label = props.label;
	if (!record.segment || !record.segment[field] || !record.segment[field].values || record.segment[field].values.length<=0) {
    return <div><br /><label className="MuiFormLabel-root MuiInputLabel-root RaLabeled-label-392 MuiInputLabel-shrink" data-shrink="true">
      <span>{label} [Not set]</span>
    </label></div>;
  }
	var arr = record.segment[field].values.split('\n');
	return (
		<div>
	 		<br />
	 		<label className="MuiFormLabel-root MuiInputLabel-root RaLabeled-label-392 MuiInputLabel-shrink" data-shrink="true">
	 			<span>{label} {record.segment[field].exclude ? '[EXCLUDE]' : ''}</span>
	 		</label>
	 		<br />
	 		<span className="MuiTypography-root MuiTypography-body2">
	 			{arr.length > 5 ? (arr.splice(0, 5).join(' ') + ' ...') : arr.join(' ')}
	 		</span>
	</div>
	)
}
const FilterListField = (props) => {
	let record = props.record;
	let field = props.field;
	let label = props.label;
	if (record.segment && record.segment[field] && record.segment[field].values && record.segment[field].values.length>0) {return (
		<div>
			<br />
			<label className="MuiFormLabel-root MuiInputLabel-root RaLabeled-label-392 MuiInputLabel-shrink" data-shrink="true">
				<span>{label} {record.segment[field].exclude ? '[EXCLUDE]' : ''}</span>
			</label>
			<ul>
				{record.segment[field].values.map(item => (
					<li key={item}>{item}</li>
				))}
			</ul>
		</div>
	) } else return (
    <div>
			<br />
			<label className="MuiFormLabel-root MuiInputLabel-root RaLabeled-label-392 MuiInputLabel-shrink" data-shrink="true">
				<span>{label} [Not set]</span>
			</label>
		</div>
  )
	return <div />
}

const CampaignPreview = props => {
	return (
		<Show {...props} actions={false}>
			<SimpleShowLayout>
                {props.record.pace != null && <NumberField label="Pace %" source="pace" />}
				{props.record.frequency_cap != null && <span>Frequency Cap</span>}
				{props.record.frequency_cap != null && <NumberField label="Cap" source="frequency_cap.cap" />}
				{props.record.frequency_cap != null && <NumberField label="Hours" source="frequency_cap.hours" />}
        {props.record.advertiser_id != null && <ReferenceField label="Advertiser" source="advertiser_id" reference="advertisers">
					<TextField source="name" /></ReferenceField>}
                {props.record.creatives != null && 
                    <ReferenceArrayField reference="creatives" source="creatives" label="Selected Creatives">
                        <SingleFieldList><FunctionField render={record => ` > ${record.name}`} /></SingleFieldList>
                    </ReferenceArrayField>}
				<FilterArrayField field='filter_top_level_domain' label='Filter Domains'/>
				<FilterArrayField field='filter_page_url' label='Filter Page URLs'/>
				<FilterListField field='filter_country' label='Filter Countries'/>
				<FilterListField field='filter_state' label='Filter States'/>
				<FilterListField field='filter_device_type' label='Filter Devices'/>
				{/* <FilterArrayField field='filter_adsize' label='Filter Ad Sizes'/> */}
				<FilterArrayField field='filter_divid' label='Filter Div IDs'/>
        <FilterListField field='filter_viewability' label='Filter Viewability' />
        {<FilterListField field='filter_os' label='Filter Operating Systems' />}
				{<FilterArrayField field='filter_asn' label='Filter ASN Numbers' />}
			</SimpleShowLayout>
		</Show>
	)
}
export const AdCampaignList = (props) => (
  <List {...props} title="Campaigns" 
    filter={{ type: ['DIRECT', 'PERFORMANCE'] }}
    filters={<CampaignFilter {...props} />} 
    perPage={25} 
    bulkActionButtons={false}>
		<Datagrid rowClick="edit" expand={<CampaignPreview parent={props}/>}>
			<TextField source="code" label="ID" />
			<TextField source="name" label="Name" />
			{/* The resolved gate, in the same column position as the advertiser list.
			    Without it this screen had no answer to "is it delivering": `Active`
			    below is only the on/off switch, and the Daily Progress badge reads
			    daily_revenue_limit_active alone and only for DIRECT - so campaign
			    1709, stopped dead by its LIFETIME cap, read here as a healthy active
			    campaign. That is the same defect NBU-7 fixed on the advertiser list,
			    left in place on this one because the reported bug was the advertiser's
			    view.

			    AUDIENCE.OPS keeps the cause and the timestamp in the tooltip and drops
			    the advertiser remedy. */}
			<FunctionField label="Status"
				render={record => <CampaignStatusChip record={record} audience={AUDIENCE.OPS} />} />
			<TextField source="pace" label="%Pace" />
      <FunctionField source="bid_price" label="$Price" render={record =>
				<span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
					<span>{record.bid_price}</span>
					<span style={{ fontSize: '0.65em', color: 'gray', lineHeight: 1.3 }}>
						{record.hourly_revenue_limit != null && <div>H: ${record.hourly_revenue_limit}</div>}
						{record.daily_revenue_limit != null && <div>D: ${record.daily_revenue_limit}</div>}
					</span>
					{record.dynamic_pricing_enabled != null && <span style={{
						display: 'inline-block',
						width: 8,
						height: 8,
						borderRadius: '50%',
						backgroundColor: record.dynamic_pricing_enabled ? '#e91e63' : 'gray',
					}} title={record.dynamic_pricing_enabled ? 'Dynamic Pricing ON' : 'Dynamic Pricing OFF'} />}
				</span>
			} />
			<DateField source="updated_at" label="Update Date" />
			<DateField source="created_at" label="Creation Date" />
			<BooleanField source="active" label="Active" />
			<FunctionField label="Daily Progress" render={record =>
				record.type === 'DIRECT'
					? <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
						{progress(record.current_daily_revenue, record.daily_revenue_limit)}
						{/* Same badge and same rule as the campaign form: only an explicit
						    false is paused. This used to be an inline copy testing
						    falsiness, so it flagged every campaign the budget coordinator
						    had not written yet, and it also ORed in !record.active -
						    conflating "switched off by a human" with "budget exhausted",
						    which the Active column beside it already shows. */}
						{active(record.daily_revenue_limit_active)}
					</span>
					: ''
			} />
			<CopyButton resource="adcampaigns" />
			<EditButton variant="contained" color="primary" />
		</Datagrid>
	</List>
);

// ValidatingSaveButton, not SaveButton (NBU-9): this form validates fields on
// both the Settings and Limits tabs, and react-admin renders every tab and
// hides the inactive ones - so a blocked save used to report only that the form
// was invalid, with the offending field on a tab the user could not see. Paired
// with ErrorAwareFormTabs on the TabbedForm below, which marks and navigates to
// the tab holding the error.
const CustomToolbar = props => (
	<Toolbar {...props}>
		<ValidatingSaveButton />
		<CopyButton resource="adcampaigns" record={props.record} />
		<br />
		<DateField source="updated_at" label="Update date" style={{ padding: '10px' }} showTime />
		<TextField source="updated_name" label="" style={{ padding: '10px' }} />
	</Toolbar>
);
const timezones = [
{id: 'Pacific/Pago_Pago', name: '(GMT-11:00) Pacific/Pago_Pago'},
{id: 'Pacific/Honolulu', name: '(GMT-10:00) Pacific/Honolulu'},
{id: 'America/Los_Angeles', name: '(GMT-08:00) America/Los_Angeles'},
{id: 'America/Denver', name: '(GMT-07:00) America/Denver'},
{id: 'America/Chicago', name: '(GMT-06:00) America/Chicago'},
{id: 'America/New_York', name: '(GMT-05:00) America/New_York'},
{id: 'America/Halifax', name: '(GMT-04:00) America/Halifax'},
{id: 'America/Argentina/Buenos_Aires', name: '(GMT-03:00) America/Argentina/Buenos_Aires'},
{id: 'Atlantic/South_Georgia', name: '(GMT-02:00) Atlantic/South_Georgia'},
{id: 'Atlantic/Azores', name: '(GMT-01:00) Atlantic/Azores'},
{id: 'Europe/London', name: '(GMT+00:00) Europe/London'},
{id: 'Central European Time', name: '(GMT+01:00) Central European Time'},
{id: 'Asia/Jerusalem', name: '(GMT+02:00) Asia/Jerusalem'},
{id: 'Europe/Istanbul', name: '(GMT+03:00) Europe/Istanbul'},
{id: 'Asia/Baku', name: '(GMT+04:00) Asia/Baku'},
{id: 'Asia/Tashkent', name: '(GMT+05:00) Asia/Tashkent'},
{id: 'Asia/Dhaka', name: '(GMT+06:00) Asia/Dhaka'},
{id: 'Asia/Bangkok', name: '(GMT+07:00) Asia/Bangkok'},
{id: 'Asia/Shanghai', name: '(GMT+08:00) Asia/Shanghai'},
{id: 'Asia/Tokyo', name: '(GMT+09:00) Asia/Tokyo'},
{id: 'Pacific/Guam', name: '(GMT+10:00) Pacific/Guam'},
{id: 'Australia/Sydney', name: '(GMT+11:00) Australia/Sydney'},
{id: 'Pacific/Majuro', name: '(GMT+12:00) Pacific/Majuro'},
{id: 'Pacific/Fiji', name: '(GMT+13:00) Pacific/Fiji'}
];

// Flight timezone choices moved to components/utils.js as FLIGHT_TIMEZONES so
// the advertiser campaign form uses the identical list - the two forms must
// never drift on which zones are offered. `timezones` above is unrelated and
// stays here: it backs the legacy Day Parting select and holds non-IANA ids
// that are real stored values on existing configs.

const useStyles = makeStyles({
  dualGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: '15px'
  },
  
  flexColumn: {
    display: 'flex',
    flexDirection: 'column'
  }
});
const progress = utils.progressBar;
const active = utils.pausedIndicator;

class AdCampaignForm extends React.Component {
  render () {
    const permissions = this.props.permissions;
    return (
      <TabbedForm toolbar={<CustomToolbar />} tabs={<ErrorAwareFormTabs />} {...this.props}>
        <FormTab label="Settings">
          <TextField source="code" label="Campaign ID" />

          {/* Which gate is actually stopping delivery, in the same slot as on the
              advertiser form. The limit tables below already mark the exhausted
              flag, but a PAUSED chip says only THAT something closed - not which
              of the four limits it was, and not when. AUDIENCE.OPS keeps the
              cause and the timestamp and drops the advertiser remedy, which
              points at a Budget card this form does not have.

              Gated on `code`, which only a SAVED campaign has. AdCampaignCreate
              and AdCampaignEdit mount this same component and both pass
              formType="edit", so there is no create flag to read here - and
              without a gate, Create's empty record resolves to "Off" (active
              defaults false) and greets every new campaign with a red banner
              saying it is switched off. Same hazard the advertiser form avoids
              with its !isCreate guard, different signal because this form has
              none to offer. */}
          <FunctionField addLabel={false} render={record => (record && record.code
            ? <CampaignStatusBanner record={record} audience={AUDIENCE.OPS} />
            : null)} />

          {/* PERFORMANCE FIRST, above the inputs, matching the advertiser form.
              Both screens mount the same two widgets, so they show the campaign
              in the same order to whoever opens it.

              CampaignPerformancePanel owns the chart-beside-cards layout and is
              shared with the advertiser form, so the two cannot drift. The chart
              carries the range selector (last hour / 3h / 24h / 7 days) and a
              total for the selected range; the cards are the only place spend is
              shown against a CAP. */}
          <FormDataConsumer>
            {({ formData }) => (
              <CampaignPerformancePanel
                record={formData}
                campaignId={formData.code}
                hourlyLimit={formData.hourly_revenue_limit}
                dailyLimit={formData.daily_revenue_limit} />
            )}
          </FormDataConsumer>
          <br/>

          <div style={{ width: '100%' }}>
          <div style={{ width: '45%', display: 'inline-block', verticalAlign: 'top' }}>
              <Card raised>
                  <CardContent {...this.props}>
                  <BooleanInput source="active" label="Active" defaultValue={false} validate={required()} />
                  <TextInput source="name" label="Campaign Name" style={{ width: '400px' }} validate={validCampaignName} />
                  <div style={{ width: '30%' }}>
                  <ReferenceInput label="Advertiser *"
                      perPage={15}
                      sort={{ field: 'name', order: 'ASC' }}
                      filterToQuery={searchText => ({ search_name: searchText })}
                      source="advertiser_id"
                      reference="advertisers"
                      basePath='advertisers' defaultValue={101} fullWidth >
                      <AutocompleteInput optionText={record => (record && record.name) ? `${record.name} (${record.code})` : ""}
                      optionValue='code' validate={required()} sx={{ width: 1/2 }} />
                  </ReferenceInput>
                  </div>
                  <SelectInput label="Type" source="type" initialValue='DIRECT'
                  choices={[
                      {id: 'DIRECT', name: 'DIRECT / CPC'},
                      {id: 'PERFORMANCE', name: 'PERFORMANCE'}
                  ]} />
                  <br/>
                  {/* <Box display={{ md: 'block', lg: 'flex' }} fullWidth>
                  <BooleanInput source='retargeting_enabled' label='Retargeting Enabled'/>
                  <FormDataConsumer>
                  {({ formData }) => (formData.retargeting_enabled) && [
                  <NumberInput source='retargeting_price_rate' defaultValue={50} label='% Retargeting Price Rate' helperText='Retargeting Price Percentage Rate %' 
                  validate={[number(), minValue(1)]} style={{ width: '30%'}} step={1} />,
                  <FunctionField render={() => (formData.retargeting_price_rate && formData.bid_price) ? 
                    <div style={{marginLeft: '10px', marginTop: '23px'}}>Calculated Retargeting Bid Price: ${formData.bid_price/100 * formData.retargeting_price_rate}</div>
                    : '' } />
                  ]}
                  </FormDataConsumer>
                  </Box> */}

                  <ReferenceArrayInput label="Select Creatives *"
                      perPage={15}
                      sort={{ field: 'name', order: 'ASC' }}
                      filterToQuery={searchText => ({ search_name: searchText })}
                      source="creatives"
                      reference="creatives"
                      basePath='creatives'
                      style={{ width: '50%' }}
                      >
                      <AutocompleteArrayInput optionText={record => (record && record.name) ? `${record.name} (${record.code}) [${record.width}x${record.height}]` : ""}
                      optionValue="code" style={{ width: '50%' }} validate={required()}/>
                  </ReferenceArrayInput>
                  <utils.SectionHeader title="Audiences" />
                  <ArrayInput source="audience_bid_modifiers" label="">
                    <SimpleFormIterator>
                      <ReferenceInput label="Audience" source="audience_code" reference="audiences" perPage={150}
                          filterToQuery={searchText => ({ search_name: searchText })}>
                        <AutocompleteInput optionText="name" optionValue="code" />
                      </ReferenceInput>
                      <ReachSliderInput source="threshold" label="Match threshold" defaultValue={0.5} />
                      <NumberInput source="multiplier" label="Bid multiplier" defaultValue={1} min={0} max={10} step={0.1} />
                    </SimpleFormIterator>
                  </ArrayInput>
                  </CardContent>
              </Card>
          </div>
          <div style={{ width: '45%', display: 'inline-block', verticalAlign: 'top', paddingLeft: '20px' }}>
              <Card raised>
                  <CardContent>
                  <FormDataConsumer>
                  {({ formData }) => (formData.type === 'DIRECT') && [
                      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                        <NumberInput label="Bid Price (USD $)" source={'bid_price'} style={{ width: '30%'}}
                        step={0.01}
                        validate={[required(), number(), minValue(0.01)]}
                        helperText="Gross CPM price - what the advertiser pays per 1000 impressions served. Publisher payout is derived: gross x (1 - advertiser margin)."
                        />
                        {isAdminRole(permissions) && formData.advertiser_id != null &&
                        <AdvertiserMarginField advertiserId={formData.advertiser_id} style={{ width: '20%', marginLeft: '20px' }} />
                        }
                        {formData.advertiser_id != null &&
                        <AdvertiserDynamicPricingToggle advertiserId={formData.advertiser_id} style={{paddingTop: '10px', paddingLeft: '40px'}} />
                        }
                      </div>,
                      /* NBA-38. Directly under the bid, because it decides what a win costs
                         against that bid, and inside the DIRECT-only block for the same reason
                         bid_price is: the clearing price is clamped to the campaign's own bid,
                         and a PERFORMANCE campaign has no bid_price field on this form. Leaving
                         it unset on those keeps them on the bidder's own setting.

                         This screen is `adcampaigns` (menu: Campaigns, type IN DIRECT,
                         PERFORMANCE). The copy on campaigns.js is a DIFFERENT resource (menu:
                         Traffic Rules, type NOT IN DIRECT, DEAL, PERFORMANCE, AD_QUALITY_RULE).
                         The two sets are disjoint, so this is not a duplicate control - without
                         it there is no ops path to set auction_type on a direct campaign. */
                      <utils.AuctionTypeSelectInput style={{ width: '50%' }} />,
                      <br/>,
                      <utils.BudgetPacingSelectInput style={{ width: '50%' }} />,
                      <br/>,
                      <table style={{width: '50%'}}><tr><td style={{width: '70%'}}><NumberInput label="Hourly Spend Limit (USD $)" source="hourly_revenue_limit" style={{ width: '100%'}}
                      step={0.01}
                      validate={[requireSomeSpendLimit('daily_revenue_limit'), number(), minValue(0.01)]}
                      helperText="Hourly spend cap in USD (optional if a daily limit is set)."/></td>
                      <td style={{textAlign: 'left', paddingLeft: '10px', paddingBottom: '22px'}}><FunctionField render={record => progress(record.current_spend, record.hourly_revenue_limit) } /></td>
                      </tr></table>,
                      <br/>,
                      <table style={{width: '50%'}}><tr><td style={{width: '70%'}}>
                        <NumberInput label="Daily Spend Limit (USD $)" source="daily_revenue_limit" style={{ width: '100%'}}
                        step={0.01}
                        validate={[requireSomeSpendLimit('hourly_revenue_limit'), number(), minValue(0.01)]}
                        helperText="Total daily spend limit in USD. With ASAP pacing and no hourly cap, the daily budget can be spent within minutes." />
                      </td>
                      <td style={{textAlign: 'left', paddingLeft: '10px', paddingBottom: '22px'}}><FunctionField render={record => progress(record.current_daily_revenue, record.daily_revenue_limit)} /></td>
                      <td style={{textAlign: 'left', paddingLeft: '10px', paddingBottom: '15px'}}><FunctionField render={record => active(record.daily_revenue_limit_active)} /></td>
                      </tr></table>,
                      <br/>,
                      <table style={{width: '50%'}}><tr><td style={{width: '70%'}}>
                        <NumberInput label="Lifetime Gross Spend Limit (USD $)" source="lifetime_revenue_limit" 
                        step={0.01}
                        style={{ width: '100%'}}
                        validate={[number(), minValue(0.01)]} 
                        helperText="Lifetime gross spend limit in USD (Optional)." />
                        </td>
                      <td style={{textAlign: 'left', paddingLeft: '10px', paddingBottom: '22px'}}><FunctionField render={record => progress(record.current_lifetime_revenue, record.lifetime_revenue_limit) } /></td>
                      <td style={{textAlign: 'left', paddingLeft: '10px', paddingBottom: '15px'}}><FunctionField render={record => active(record.lifetime_revenue_limit_active)} /></td>
                      </tr></table>,
                      <br/>,
                      <table style={{width: '60%'}}><tr><td style={{width: '70%'}}>
                        <NumberInput label="Lifetime Impressions Limit" source="lifetime_impressions_limit" style={{ width: '100%'}}
                        step={1}
                        validate={[number(), minValue(1)]}
                        helperText="Lifetime impressions limit (Optional)." />
                      </td>
                      <td style={{textAlign: 'left', paddingLeft: '10px', paddingBottom: '22px'}}><FunctionField render={record => progress(record.current_lifetime_impressions, record.lifetime_impressions_limit) } /></td>
                      <td style={{textAlign: 'left', paddingLeft: '10px', paddingBottom: '15px'}}><FunctionField render={record => active(record.lifetime_impressions_limit_active)} /></td>
                      </tr></table>,
                      <br/>,
                      ]
                  }
                  </FormDataConsumer>
                  <FormDataConsumer>{({ formData }) => (formData.type === 'PERFORMANCE') && [
                      <SelectInput source="priority" label="Priority" initialValue={"1"}
                      choices={[{id:12, name: 'HIGH'}, {id:11, name: 'MEDIUM'}, {id:10, name: 'LOW'}]}/>
                      ]
                  }</FormDataConsumer>
                  <br/>
                  <NumberInput label="Hourly Clicks Limit" source="hourly_clicks_limit" step={1} validate={[number(), minValue(0), validInteger]} style={{ width: '50%'}}/>
                  <br/>
                  <NumberInput label="Daily Clicks Limit" source="daily_clicks_limit" step={1} validate={[number(), minValue(0), validInteger]} style={{ width: '50%'}}/>
                  <br/>
                  <NumberInput label="CPC Price (USD $)" source="cpc_price" style={{ width: '50%'}}/>
                  </CardContent>
              </Card>
          </div>
          </div>
          <br/><br/>
          <TextInput source="type" defaultValue='DIRECT' disabled style={{ visibility: 'hidden', display: 'none' }}/>

          <ReferenceArrayField
            reference='creatives'
            source='creatives'
            basePath='/creatives'
            label="Selected Creatives">
                <SingleFieldList><TextField source="name" /></SingleFieldList>
            </ReferenceArrayField>
          <br/>

        </FormTab>
        <FormTab label="Limits">
            
            <br/>
            <SelectInput label="Campaign Pace" source="pace" initialValue='100' choices={utils.PACES} />

            <br/>
            <Card style={{ width: '50%' }} raised>
                <CardHeader title="Frequency Capping" />
                <CardContent>
                    <table>
                        <tr>
                            <td><NumberInput label="Cap" source="frequency_cap.cap" min={0} step={1} validate={validFrequencyCap} /></td>
                            <td><div style={{ width: '10px' }}> </div></td>
                            <td><NumberInput label="Hours" source="frequency_cap.hours" min={0} max={168} step={1} validate={validFrequencyHours} /></td>
                        </tr>
                    </table>
                </CardContent>
            </Card>
            <br/>
            <Card style={{ width: '50%' }} raised>
                <CardHeader title="Flight Dates" />
                <CardContent>
                    <table>
                        <tr>
                            <td><DateInput source="flight_start_day" label="Flight start (day)" /></td>
                            <td><div style={{ width: '10px' }}> </div></td>
                            <td><DateInput source="flight_end_day" label="Flight end (day)" /></td>
                        </tr>
                    </table>
                    <utils.TimezoneSelectInput source="flight_timezone" label="Flight timezone" />
                </CardContent>
            </Card>
            <br/>
            <div>Day Parting</div>
            <ArrayInput source="day_parting_config">
                <SimpleFormIterator>
                <SelectInput source='timezone' label="Select Timezone..." choices={timezones} 
                    defaultValue="America/New_York" style={{ width: '350px' }}/>
                <SelectArrayInput source="days" label="Any Day" choices={[
                    { id: 2, name: 'Monday' },
                    { id: 3, name: 'Tuesday' },
                    { id: 4, name: 'Wednesday' },
                    { id: 5, name: 'Thursday' },
                    { id: 6, name: 'Friday' },
                    { id: 7, name: 'Saturday' },
                    { id: 1, name: 'Sunday' }
                    ]} style={{ width: '350px' }} />
                <SelectArrayInput style={{ width: '350px' }} source="hours" label="Any Hour" choices={[
                    { id: 0, name: '0:00 AM Midnight' },
                    { id: 1, name: '1:00 AM' },
                    { id: 2, name: '2:00 AM' },
                    { id: 3, name: '3:00 AM' },
                    { id: 4, name: '4:00 AM' },
                    { id: 5, name: '5:00 AM' },
                    { id: 6, name: '6:00 AM' },
                    { id: 7, name: '7:00 AM' },
                    { id: 8, name: '8:00 AM' },
                    { id: 9, name: '9:00 AM' },
                    { id: 10, name: '10:00 AM' },
                    { id: 11, name: '11:00 AM' },
                    { id: 12, name: '12:00 PM' },
                    { id: 13, name: '1:00 PM' },
                    { id: 14, name: '2:00 PM' },
                    { id: 15, name: '3:00 PM' },
                    { id: 16, name: '4:00 PM' },
                    { id: 17, name: '5:00 PM' },
                    { id: 18, name: '6:00 PM' },
                    { id: 19, name: '7:00 PM' },
                    { id: 20, name: '8:00 PM' },
                    { id: 21, name: '9:00 PM' },
                    { id: 22, name: '10:00 PM' },
                    { id: 23, name: '11:00 PM' }
                    ]} />
                </SimpleFormIterator>
            </ArrayInput>
        </FormTab>
        <FormTab label="Filters">
          <Box className={this.props.classes.dualGrid} fullWidth record={this.props.record}>
            <Box className={this.props.classes.flexColumn} fullWidth>
              <PublisherFilter {...this.props}/>
              <SegmentFilter {...this.props}/>

              <TopLevelDomainFilter {...this.props}/>

              <PageUrlFilter {...this.props}/>

              <ChannelFilter {...this.props} defaultValues={['web', 'amp']} />

              <DivIDFilter {...this.props}/>

              <PlacementFilter {...this.props}/>

              <IABCategoriesFilter {...this.props}/>

              <ImpressionTypeFilter {...this.props} defaultValues={['BANNER']}/>
            </Box>
            <Box className={this.props.classes.flexColumn} fullWidth>
              <CountryFilter {...this.props}/>

              <StateFilter {...this.props}/>

              <DeviceTypeFilter {...this.props}/>

              <MultipleChoiceFilter {...this.props} title='Browsers' filterName='filter_browser' matchType='equalsIgnoreCase' matchTypeHidden={true} choices={browserChoices} />

              <ViewabilityFilter {...this.props}/>

              <OSFilter {...this.props}/>

              <AsnFilter {...this.props}/>

              <IpListsFilter {...this.props}/>

              <UserAgentFilter {...this.props} />

            </Box>
          </Box>

          {/* <TextInput source="segment.filter_impression_type.match_type" initialValue="equalsIgnoreCase" disabled style={{ visibility: 'hidden', display: 'none' }} />
          <BooleanInput source="segment.filter_impression_type.exclude" initialValue={false} disabled style={{ width: '1%', visibility: 'hidden', display: 'none' }} />
          <TextInput source="segment.filter_impression_type.values" initialValue={['BANNER']} disabled style={{ width: '1%', visibility: 'hidden', display: 'none' }} /> */}

        </FormTab>
      </TabbedForm>
    )
  }
}

export const AdCampaignEdit = ({ permissions, ...props }) => {
  const classes = useStyles(props);
  return (
    <Edit title={<CampaignTitle />} mutationMode="pessimistic" {...props}>
      <AdCampaignForm formType="edit" permissions={permissions} classes={classes} {...props}/>
    </Edit>
  )
}

export const AdCampaignCreate = ({ permissions, ...props }) => {
  const classes = useStyles(props);
  return (
    <Create title={<CampaignTitle />} mutationMode="pessimistic" {...props}>
      <AdCampaignForm formType="edit" permissions={permissions} classes={classes} {...props}/>
    </Create>
  )
}
